import React, { FC } from 'react';

import { useCalculationContextData } from '@/components/modules/caclulator';

import { useTranslate } from '@/shared/hooks/use-translate';

import * as Styled from './styled';

type TProps = { productId: number };

export const BlockArentaInfo: FC<TProps> = ({ productId }) => {
    const { t } = useTranslate();

    const { checkedBuyout } = useCalculationContextData(productId);

    if (checkedBuyout) {
        return (
            <Styled.Wrapper>
                {t('За некоторые товары мы можем попросить аванс.')}
                <br />
                {t(
                    'Мы рассчитаем авансовый платеж после создания заявки и спишем его в счет оплаты первого платежа по графику',
                )}
            </Styled.Wrapper>
        );
    }

    return (
        <Styled.Wrapper>
            {t('За некоторые товары мы можем попросить залог')}
            <br />
            {t('Сумма залога будет рассчитана после создания заявки')}
        </Styled.Wrapper>
    );
};
